import { useMutation, useQueryClient } from '@tanstack/react-query'
import { coatTypeIndexOptions, coatTypeStoreMutation } from '$api-client/@tanstack/react-query.gen'
import { CreateCoatTypeForm, CreateCoatTypeSchema } from '$features/settings/forms/coat-type/create'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Router } from '$utils/router'
import { NavigableModal } from '$components'
import { ToastHelper, ToastType } from '$components'
import { useNavigate } from 'react-router'

export function CreateCoatTypeModal() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleClose = () => navigate(Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsPetOptionsCoats))

  const mutation = useMutation({
    ...coatTypeStoreMutation(),
    onSuccess: () => {
      ToastHelper.createSuccess(ToastType.CoatType)
      queryClient.invalidateQueries({ queryKey: coatTypeIndexOptions().queryKey })
      handleClose()
    },
    onError: () => ToastHelper.createError(ToastType.CoatType),
  })

  const handleSubmit = (values: CreateCoatTypeSchema) => {
    mutation.mutate({
      body: { name: values.name },
    })
  }

  return (
    <CreateCoatTypeForm
      isLoading={mutation.isPending}
      onSubmit={handleSubmit}
      onCancel={handleClose}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>Add Coat Type</NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <CreateCoatTypeForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <CreateCoatTypeForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </CreateCoatTypeForm>
  )
}
